import { createSlice } from '@reduxjs/toolkit';

export interface DataState {
  id: string;
  chart_title: string;
  chart_project: string;
  chart_short_desc: string;
  chart_long_desc: string;
  is_deleted: boolean;
  chart_reports: null[] | null;
  has_edited_title: boolean;
  config: any;
  updated_at?: string;
  chart_project_name: string;
  chart_project_auto_charts_executed: boolean;
  created_by_auto_charts: boolean;
}

const initialState: DataState = {
  id: '',
  chart_title: '',
  chart_project: '',
  chart_short_desc: '',
  chart_long_desc: '',
  is_deleted: false,
  chart_reports: [],
  has_edited_title: false,
  config: {},
  updated_at: '',
  chart_project_name: '',
  chart_project_auto_charts_executed: false,
  created_by_auto_charts: false
};

export const currentChartData = createSlice({
  name: 'currentChartPreviewData',
  initialState,
  reducers: {
    // eslint-disable-next-line arrow-body-style
    setChartData: (state, { payload }) => {
      return { ...state, ...payload };
    },
    updateConfig: (state, { payload }) => {
      const data = { ...state.config, [payload.field]: payload.value };

      return { ...state, config: data };
    }
  }
});

export const { setChartData, updateConfig } = currentChartData.actions;

export default currentChartData.reducer;
